var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"eu-form-section",attrs:{"id":`eu-form-${_vm.id}-section`}},[_c('form',_vm._b({attrs:{"action":_vm.formAction,"id":`eu-form-${_vm.id}`},on:{"submit":_vm.handleSubmit}},'form',_vm.$attrs,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }